import angular from 'angular';
import moment from 'moment';
const controllerInfo = {
    module: 'ib-gift-cards-configuration-module',
    inject:['$scope', 'localStorageService', '$window', '$timeout', '$rootScope'],
    required: []
};
export class IbPopoverController implements ng.IController {
    public model: any;
    public isOpen: any;
    public text : string;
    public outboundFlight: any;
    public passengers: any;
    public returnFlight: any;
    public multicityData : any;
    public flowApp: any;
    public triggerTitle: any;
    constructor (private $scope, private localStorageService, private $window, private $timeout, private $rootScope: CommonsRootScope) {
        this.isOpen = false;
        this.text = '';
        this.outboundFlight;
        this.passengers;
        this.returnFlight;
        this.multicityData = [];
        this.flowApp;
        this.triggerTitle;
    }

    $onInit () {
        this.triggerTitle = this.$window.innerWidth < 1024 ? 'CLICK_FOR_MORE_INFORMATION_TEXT' : '';

        this.$rootScope.$on('outside-popover', () => {
            if (this.isOpen) {
                this.close();
            }
        });
        this.$rootScope.$on('outside-popover-enter', () => {
            if (!this.isOpen) {
                this.$timeout(() => {
                    this.isOpen = true;
                });
            }
        });
    }
    close = (): void => {
        this.$timeout(() => {
            this.isOpen = false;
        });
    };
    //Function to change state isOpen
    isFocusIn = (param:any) : void => {
        this.$timeout( ()=> {
            this.isOpen = param;
        });
    };
    hoverLargeView = (event:any, text:string): void => {
        const windowWidth = this.$window.innerWidth;
        this.$timeout( ()=> {
            this.text = text;
            this.triggerTitle = windowWidth < 1024 ? 'CLICK_FOR_MORE_INFORMATION_TEXT' : '';
        });
        if (windowWidth >= 1024 && (event.type === 'mouseenter' || event.type === 'focus') && !this.isOpen) {
            this.isFocusIn(true);
        } else if(windowWidth >= 1024 && event.type === 'mouseleave' && this.isOpen) {
            this.close();
        } else if (windowWidth >= 1024 && event.type === 'click' && this.isOpen) {
            this.isOpen = true;
        } else if (windowWidth < 1024 && event.type === 'click' && !this.isOpen) {
            this.isFocusIn(true);
        } else if (windowWidth < 1024 && (event.type === 'mouseenter' || event.type === 'mouseleave') && this.isOpen) {
            this.isFocusIn(true);
        } else {
            this.close();
        }
    };
    showData = (outboundFlight, returnFligh, numberPassengers): void => {
        this.flowApp = this.localStorageService.get('flowApp');
        this.outboundFlight = outboundFlight;
        this.returnFlight = returnFligh;
        this.passengers = numberPassengers;
    };

    showMulticities = (cities):void =>{
        let i;
        this.multicityData = [];
        this.passengers = cities[0].passengers;
        for (i = 0; i < cities.length; i++) {
            this.multicityData.push({ date: moment(cities[i].dates.outboundFlight).format('DD/MM/YYYY'), origin: cities[i].originCity.code, destination: cities[i].destinationCity.code });
        }
    };

    /**
         * Emits event to open modal
         * @param {Int} position Position on page for show modal with different options
         * depending of position
         */
    showModalToAvailability = (position):void => {
        this.$scope.$emit('showModalAvailability', position);
    };
}
try {
    IbPopoverController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(IbPopoverController.name, IbPopoverController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    IbPopoverController.$inject = controllerInfo.inject;
    mod.controller(IbPopoverController.name, IbPopoverController);
}
